export default __webpack_public_path__ + "static/media/SWT1140.34I-40893_-24199_0.7d0064d9.jpg";